import React, { useState } from 'react';
import { Form, Input, Row, Spin, Modal, Button, Space } from 'antd';
import { message } from 'components/common';
import { editTag } from 'services/orderTag';
import { FormLabel } from 'components/common';
import { leaveEditForm } from 'utils';
import { CloseOutlined, LoadingOutlined, SaveOutlined } from '@ant-design/icons';

interface CreateTagProps {
  visible: boolean;
  onHide: () => void;
  onRefresh: () => void;
  tag?: TagRow;
}
// eslint-disable-next-line
export default (props: CreateTagProps) => {
  const { visible, onHide, onRefresh, tag } = props;
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const handleEdit = async () => {
    const params = await form.validateFields();
    if (params.errorFields) return;
    if (!tag) return;
    setLoading(true);
    try {
      const result = await editTag(
        tag.tagNum,
        params.tagName,
        params.TagDescription
      );
      setLoading(false);
      if (!result.error) {
        form.resetFields();
        onHide();
        onRefresh();
        message.success({ content: 'Saved Successfully！' });
      } else {
        message.error({ content: result.error });
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const handleCloseModal = React.useCallback(async () => {
    const cancel = await leaveEditForm(tag, form);
    if (cancel) {
      onHide();
    }
  }, [onHide, tag, form]);

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
  };
  return (
    <Modal
      title="Rename Order Tag"
      centered
      visible={visible}
      maskClosable={false}
      width={600}
      destroyOnClose={true}
      onCancel={handleCloseModal}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            <Button
              key="submit"
              type="primary"
              onClick={handleEdit}
              loading={loading}
              icon={loading ? <LoadingOutlined /> : <SaveOutlined />}
            >
              {loading ? 'Saving' : 'Save'}
            </Button>
            <Button onClick={handleCloseModal} icon={<CloseOutlined />}>Cancel</Button>
          </Space>
        </Row>
      }
    >
      <Spin
        spinning={loading}
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <Form {...layout} form={form} style={{ marginTop: 20 }}>
          <Form.Item
            name="tagName"
            initialValue={tag?.tagName}
            label={<FormLabel>Name</FormLabel>}
            rules={[{ required: true, message: 'Please input tag name!' }]}
          >
            <Input placeholder="input tag name" />
          </Form.Item>

          <Form.Item
            name="TagDescription"
            initialValue={tag?.tagDescription}
            label={<FormLabel>Description</FormLabel>}
          >
            <Input.TextArea rows={3} placeholder="input description" />
          </Form.Item>

          {/* <Form.Item name="brandDesc" label={<FormLabel>Notes</FormLabel>}>
            <Input.TextArea rows={2} />
          </Form.Item> */}
        </Form>
      </Spin>
    </Modal>
  );
};
